// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WAINz {
    flex: 1;
    overflow-y: auto;
}

.bUvDT {
    padding: 20px;
}

.py229 {
    margin-bottom: 16px;
}

.DwRlE {
    border-radius: 20px;
    padding: 18px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.uJdJd {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
}

.HO5n5 {
    font-size: 17px;
    font-weight: 600;
    margin-left: 10px;
    letter-spacing: 0.3px;
}

.QMJZy {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
}

.zzEVD {
    flex-basis: 48%;
    padding: 16px;
    border-width: 2px;
    border-style: solid;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
}

.zzEVD:hover {
    transform: scale(0.98);
}

.zzEVD:active {
    opacity: 0.7;
    transform: scale(0.96);
}

.zwlqp {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
}

.fYORG {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
}

.tLdim {
    flex-basis: 48%;
    padding: 16px;
    border-width: 2px;
    border-style: solid;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
}

.tLdim:hover {
    transform: scale(0.98);
}

.tLdim:active {
    opacity: 0.7;
    transform: scale(0.96);
}

.zr4cI {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}

.vlVAD {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 4px;
}

.eYrl1 {
    flex: 1;
    margin-right: 16px;
}

.rvB2w {
    display: block;
    font-size: 16px;
    font-weight: 500;
}

.bhQu9 {
    display: block;
    font-size: 13px;
    margin-top: 2px;
}

/* Custom switch/toggle */
.mkBAl {
    position: relative;
    display: inline-block;
    width: 51px;
    height: 31px;
}

.mkBAl input {
    opacity: 0;
    width: 0;
    height: 0;
}

.tG5Vw {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.3s;
    border-radius: 31px;
}

.tG5Vw::before {
    position: absolute;
    content: "";
    height: 27px;
    width: 27px;
    left: 2px;
    bottom: 2px;
    background-color: #f4f3f4;
    transition: 0.3s;
    border-radius: 50%;
}

.mkBAl input:checked + .tG5Vw::before {
    transform: translateX(20px);
}

.MDezi {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.yjRSr {
    display: flex;
    flex-direction: row;
    padding: 16px;
    border-radius: 14px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    transition: all 0.15s ease;
}

.yjRSr:hover {
    opacity: 0.9;
}

.yjRSr:active {
    opacity: 0.85;
    transform: scale(0.98);
}

.FZsgM {
    margin-right: 8px;
}

.J2Qm3 {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.3px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/settings/Settings.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB","sourcesContent":[".scrollView {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.container {\n    padding: 20px;\n}\n\n.resetButtonTop {\n    margin-bottom: 16px;\n}\n\n.card {\n    border-radius: 20px;\n    padding: 18px;\n    margin-bottom: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.cardHeader {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.cardTitle {\n    font-size: 17px;\n    font-weight: 600;\n    margin-left: 10px;\n    letter-spacing: 0.3px;\n}\n\n.optionsGrid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.optionButton {\n    flex-basis: 48%;\n    padding: 16px;\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.optionButton:hover {\n    transform: scale(0.98);\n}\n\n.optionButton:active {\n    opacity: 0.7;\n    transform: scale(0.96);\n}\n\n.optionText {\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.healthOptionsRow {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.healthOption {\n    flex-basis: 48%;\n    padding: 16px;\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.healthOption:hover {\n    transform: scale(0.98);\n}\n\n.healthOption:active {\n    opacity: 0.7;\n    transform: scale(0.96);\n}\n\n.healthOptionText {\n    font-size: 24px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.switchRow {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 4px;\n}\n\n.switchLabelContainer {\n    flex: 1;\n    margin-right: 16px;\n}\n\n.switchLabel {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.switchDescription {\n    display: block;\n    font-size: 13px;\n    margin-top: 2px;\n}\n\n/* Custom switch/toggle */\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 51px;\n    height: 31px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transition: 0.3s;\n    border-radius: 31px;\n}\n\n.slider::before {\n    position: absolute;\n    content: \"\";\n    height: 27px;\n    width: 27px;\n    left: 2px;\n    bottom: 2px;\n    background-color: #f4f3f4;\n    transition: 0.3s;\n    border-radius: 50%;\n}\n\n.switch input:checked + .slider::before {\n    transform: translateX(20px);\n}\n\n.buttonsContainer {\n    margin-top: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.actionButton {\n    display: flex;\n    flex-direction: row;\n    padding: 16px;\n    border-radius: 14px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border: none;\n    transition: all 0.15s ease;\n}\n\n.actionButton:hover {\n    opacity: 0.9;\n}\n\n.actionButton:active {\n    opacity: 0.85;\n    transform: scale(0.98);\n}\n\n.buttonIcon {\n    margin-right: 8px;\n}\n\n.actionButtonText {\n    font-size: 17px;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollView": `WAINz`,
	"container": `bUvDT`,
	"resetButtonTop": `py229`,
	"card": `DwRlE`,
	"cardHeader": `uJdJd`,
	"cardTitle": `HO5n5`,
	"optionsGrid": `QMJZy`,
	"optionButton": `zzEVD`,
	"optionText": `zwlqp`,
	"healthOptionsRow": `fYORG`,
	"healthOption": `tLdim`,
	"healthOptionText": `zr4cI`,
	"switchRow": `vlVAD`,
	"switchLabelContainer": `eYrl1`,
	"switchLabel": `rvB2w`,
	"switchDescription": `bhQu9`,
	"switch": `mkBAl`,
	"slider": `tG5Vw`,
	"buttonsContainer": `MDezi`,
	"actionButton": `yjRSr`,
	"buttonIcon": `FZsgM`,
	"actionButtonText": `J2Qm3`
};
export default ___CSS_LOADER_EXPORT___;
